import ProgressBarSteps from '../../../util/progress-bar/ProgressBarSteps'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const RegistrationStepsProgressBar = () => {
  const { steps, completedSteps } = useSelector(state => state.programRegistration)
  const { t } = useTranslation()

  return (
    <ProgressBarSteps
      currentStep={completedSteps.length}
      stepsNumber={steps.length}
      stepNames={steps.map(step => t(`programs.registration.steps.${step}`))}
    />
  )
}

export default RegistrationStepsProgressBar
